<template>
<div id="header">
   <!-- Navigation Drawer Start -->
    <v-navigation-drawer temporary fixed disable-resize-watcher :clipped="clipped" v-model="sideNav" app class="">
      <v-list>
        <v-list-tile value="true" v-for="(item, index) in menuItems" :key="index" router :to="item.link">
          <v-list-tile-action>
            <v-icon v-html="item.icon"></v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title v-text="item.title"></v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <!-- Navigation Drawer End -->
    <!-- Toolbar -->
    <v-toolbar dark fixed app :clipped-left="clipped" class="blue-grey darken-2">
      <v-toolbar-side-icon @click.native.stop="sideNav = !sideNav" class="hidden-sm-and-up"></v-toolbar-side-icon>
      <v-toolbar-title router :to="home">
        <router-link to="/" tag="span" style="cursor:pointer">Smolin BudgetPlan</router-link>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-xs-only">
        <v-btn flat v-for="(item,index) in menuItems" :key="index" router :to="item.link">
          <v-icon v-if="item.icon" left>{{ item.icon }}</v-icon>
          <span>{{ item.title }}</span>
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'HeaderPartial',
  data () {
    return {
      fixed: false,
      clipped: true,
      sideNav: false,
      title: 'Smolin BudgetPlan',
      drawer: true
    }
  },
  computed: {
    menuItems () {
      let menuItems = [{
        icon: '',
        title: 'Unternehmen',
        link: 'company'
      },
      {
        icon: '',
        title: 'Lösungen',
        link: 'solutions'
      },
      {
        icon: '',
        title: 'Beratung',
        link: 'consulting'
      },
      {
        icon: '',
        title: 'Service',
        link: 'service'
      },
      {
        icon: '',
        title: 'Kontakt',
        link: 'contact'
      }
      ]
      if (this.loggedIn) {
      //   menuItems.push({
      //     icon: 'supervisor_account',
      //     title: 'Profile',
      //     link: 'Profile'
      //   })
      // } else {
      //   menuItems.push({
      //     icon: 'face',
      //     title: 'Register',
      //     link: 'SignUp'
      //   })

      //   menuItems.push({
      //     icon: 'lock_open',
      //     title: 'Login',
      //     link: 'SignIn'
      //   })
      }

      return menuItems
    },
    ...mapGetters({
      userId: 'userId',
      loggedIn: 'loggedIn'
    }),
    userIsAuthenticated () {
      return false
    }

  },
  methods: {
    home: function () {
      this.$router.push({
        path: 'home'
      })
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/partials/HeaderPartial.vue